var map = {
	"./demos/basic/index.ts": 74709,
	"./demos/clickable/index.ts": 13006,
	"./demos/error/index.ts": 90511,
	"./demos/line/index.ts": 38733,
	"./demos/simple/index.ts": 23296,
	"./demos/vertical/index.ts": 6997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98476;